/*
 * 项目回款管理组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    message,
    Table,
    Select,
    Button,
    Statistic,
    Input,
    DatePicker,
    Tag,
    Space,
    theme,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    winWidth,
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    GetDropdownActionName,
    GetArrSpanMaxWidth,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import DetailRepaymentEntity from './DetailRepaymentEntity.js';
import RepaymentInfo from './RepaymentInfo';


const MODULENAME = CNF.navItems[0].submenu[4].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[4].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[4].url;

const { RangePicker } = DatePicker;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, refresh, preGroup, qss } = props;

    const {
        token: {
            colorSuccess,
            colorSuccessBg,
            fontSize,
            pageSize,
        },
    } = theme.useToken();

    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [openReapymentInfo, setOpenReapymentInfo] = useState(false);

    const update = useCallback((open, record = null) => {
        setRecord(record);
        setOpen(open, record);
    }, [setOpen]);

    const setOpenReapymentInfoModel = useCallback((open, record = null) => {
        setRecord(record);
        setOpenReapymentInfo(open);
    }, []);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
    */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(true, record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '项目名称', dataIndex: 'project_name', key: 'project_name', fixed: 'left', width: GetArrSpanMaxWidth(dataLists, 'project_name'), },
        {
            title: '回款金额(元)', key: 'amount', width: CNF.tableCreateTimeColumnWidth,
            render: (record) => <Button type='link' style={{ padding: 0, height: 22, width: '100%' }} onClick={() => {
                setOpenReapymentInfoModel(true, record);
            }}><Tag style={{ width: '100%' }} color={colorSuccessBg}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={record.amount} /></Tag></Button>,
        },
        { title: '回款日期', dataIndex: 'date', key: 'date', width: CNF.tableCreateTimeColumnWidth, },
        { title: '付款方户名', dataIndex: 'payer_name', key: 'payer_name', width: GetArrSpanMaxWidth(dataLists, 'payer_name'), },
        {
            title: '付款方账户', key: 'payer_account', width: GetArrSpanMaxWidth(dataLists, 'payer_account'),
            render: (record) => record.payer_account ? record.payer_account : '-'
        },
        { title: '收款方户名', dataIndex: 'beneficiary_name', key: 'beneficiary_name', width: GetArrSpanMaxWidth(dataLists, 'beneficiary_name'), },
        {
            title: '收款方账户', key: 'beneficiary_account', width: GetArrSpanMaxWidth(dataLists, 'beneficiary_account'),
            render: (record) => record.beneficiary_account ? record.beneficiary_account : '-'
        },
        { title: '回款人员', dataIndex: 'personnel', key: 'personnel', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '备注', key: 'description', width: GetArrSpanMaxWidth(dataLists, 'description'),
            render: (record) => record.description ? record.description : '-'
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, fontSize, colorSuccess, colorSuccessBg, setOpenReapymentInfoModel, dataLists]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => <>
                        总计: <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={qss?.amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={qss?.amount >= 10000 ? qss.amount / 10000 : qss.amount} /></Tag>
                        共{pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条
                    </>,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <DetailRepaymentEntity
                    refresh={refresh}
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={open}
                    setOpen={update}
                    record={record}
                    action={CNF.actionName.UPDATE}
                />
            }
            {
                record && <RepaymentInfo
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={openReapymentInfo}
                    setOpen={setOpenReapymentInfoModel}
                    record={record}
                />
            }
        </>
    );
}

const ProjectRepayment = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [qss, setQss] = useState(null);
    const [projectLists, setProjectLists] = useState([]);
    const [projectUlid, setProjectUlid] = useState('');
    const [payerName, setPayerName] = useState('');
    const [beneficiaryName, setBeneficiaryName] = useState('');
    const [personnel, setPersonnel] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleProjectUlidChange = useCallback((value) => {
        setProjectUlid(value || undefined);
        setCurrentIndex(1);
    }, []);
    const handlePayerNameChange = useCallback((e) => {
        setPayerName(e.target.value);
        setCurrentIndex(1);
    }, []);
    const handleBeneficiaryNameChange = useCallback((e) => {
        setBeneficiaryName(e.target.value);
        setCurrentIndex(1);
    }, []);
    const handlePersonnelChange = useCallback((e) => {
        setPersonnel(e.target.value);
        setCurrentIndex(1);
    }, []);
    const handleTimeIntervalChange = useCallback((_, dateString) => {
        setStartDate(dateString ? dateString[0] : '');
        setEndDate(dateString ? dateString[1] : '');
        setCurrentIndex(1);
    }, []);

    useEffect(() => {
        /***
         * 获取项目下拉列表
         */
        const projectDDList = () => {
            const params = {
                rss: 'list',
                page_size: CNF.maxPageSize,
                current_index: 1
            };
            $.ajax({
                url: `${CNF.api}projects/bases${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET',
            }).done((data) => {
                if (data.res === 0) {
                    setProjectLists(data.dat || []);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }).fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            })
        }
        projectDDList();
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            project_ulid: projectUlid,
            payer_name: payerName,
            beneficiary_name: beneficiaryName,
            personnel,
            start_date: startDate,
            end_date: endDate,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
                setQss(data.qss || null);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, projectUlid, payerName, beneficiaryName, personnel, startDate, endDate]);

    /***
    * 导出为 Excel
    */
    const exportAsExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目回款-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目回款明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目名称',
                    '回款金额(元)',
                    '回款日期',
                    '付款方户名',
                    '付款方账户',
                    '收款方户名',
                    '收款方账户',
                    '回款人员',
                    '备注'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
    */
    const exportGetData = () => {
        let params = {
            page_size: CNF.maxPageSize,
            current_index: currentIndex,
            project_ulid: projectUlid,
            payer_name: payerName,
            beneficiary_name: beneficiaryName,
            personnel,
            start_date: startDate,
            end_date: endDate,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    //  删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['project_number'];
                        delete item['create_username'];
                        delete item['create_displayname'];
                        delete item['create_time'];
                        delete item['image_uri'];
                        d.push(item);
                    }
                    exportAsExecl(d);
                } else {
                    exportAsExecl([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    showSearch
                    allowClear
                    placeholder='请选择项目'
                    style={{ minWidth: 300 }}
                    onChange={handleProjectUlidChange}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={projectLists && projectLists.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.name,
                    }))}
                />
                <Input
                    placeholder='付款方户名'
                    value={payerName}
                    onChange={handlePayerNameChange}
                />
                <Input
                    placeholder='收款方户名'
                    value={beneficiaryName}
                    onChange={handleBeneficiaryNameChange}
                />
                <Input
                    placeholder='回款人员'
                    value={personnel}
                    onChange={handlePersonnelChange}

                />
                <RangePicker
                    format='YYYY-MM-DD'
                    placeholder={['开始日期', '结束日期']}
                    style={{ width: '100%' }}
                    onChange={handleTimeIntervalChange}
                />
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                refresh={refresh}
                loading={loading}
                qss={qss}
            />
        </>
    );
}

export default ProjectRepayment;